/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import MarginBarChart from '../../MarginBarChart/MarginBarChart';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MarginBarChartTMGSL = ({ datasets, chartData ,indexAxis, height }) => {
    
    const data = {
        labels: chartData?.map((item) => item.label),
        datasets: datasets,
      };

      const options = {
        indexAxis: indexAxis,
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 30,
          },
        },
        plugins: {
          legend: {
            labels: {
              usePointStyle: true,
              pointStyle: "circle",
              font: {
                size: 10
              },
            },
            position: "bottom",
          }, 
          // datalabels: {
          //   color: "black",
          //   textStrokeColor: "white",
          //   textStrokeWidth: 4,
          //   anchor: "end",
          //   align: "end",
          //   // rotation: 90, 
          //   // display: "auto",
          //   // clip: "auto",
          //   font: {
          //     weight: "bold",
          //     size: 10,
          //   },
          // },
          datalabels: {
            display:false
          },
          tooltip: {
            intersect: false,
          },    
        },
        scales: {
          x: {
            stacked: true,
            display: true,
            fontWeight: "bold",
            ticks: {
              display: true,
            },
            grid: {
              display: false,
            },
          },
          y: {
            stacked: "normalized",
            display: true,
            fontWeight: "bold",
            ticks: {
              display: true,
            },
            grid: {
              display: true,
            },
          },
        },
      };

    return (
        <div style={{ width: '100%', height: height }}>
            <Bar data={data} options={options} />
        </div>
    );
};

export default MarginBarChartTMGSL;
